import $ from 'jquery';
import img_sprite from '../../images/maps/sprite-sm.png';

class YandexMap {
    constructor(container_id, center_coords, zoom_level, window){
        this.map = new window.ymaps.Map(container_id, {
            center: center_coords,
            zoom: zoom_level,
            controls: ['zoomControl','fullscreenControl']
        });
    }

    get Ymap() {
        return this.map;
    }

    drawPlacemarks() {
        let _this = this;
        $('.address-panel').each(function () {
            let $tr = $(this);
            let lat = $tr.data('geo-lat');
            let lon = $tr.data('geo-lon');
            let avail = $tr.data('geo-avail');
            let rect = (avail !== 1) ? [[86,0], [170, 85]] : [[0,0], [85, 85]];
            let id = $tr.data('geo-id');
            let whours = '';
            let avail_str = '';
            if(avail === 1) avail_str = ' - <span class="text-success">Товар в наличии</span>';
            else if(avail === 0) avail_str = ' - <span class="text-danger">Нет в наличии</span>';


                $.each(window.stocks[id]['whours'], function (i, e) {
                    whours = whours + '<li><strong> ' + i + ':</strong> ' + e + '</li>';
                });


            let baloon_tmpl = `
            <div><strong>Магазин "Автотрейд"</strong></div>
            <address>${window.stocks[id]['address']} ${avail_str}</address>
            <div><strong><i class="icofont-phone-circle"></i>${window.stocks[id]['phone']}</strong></div>
            <ol>
                ${whours}
            </ol>
            <div>
                <a class="font-bold" href="https://yandex.ru/maps/?ll=${[lon, lat].join(',')}&z=16&l=map&rtext=~${[lat, lon].join(',')}&rtt=auto" target="_blank">
                    Построить маршрут
                    <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-bottom: -2px;">
                        <path d="M0.589996 10.59L5.17 6L0.589996 1.41L2 0L8 6L2 12L0.589996 10.59Z" fill="#0C54A0"/>
                    </svg>
                </a>
            </div>
            `;//'<address>'+window.stocks[id]['address']+'</address>';
            let baloon = window.ymaps.templateLayoutFactory.createClass(baloon_tmpl, {
                getShape: function () {
                    let parentElement = this.getParentElement();
                    if (!parentElement) {
                        return;
                    }
                    this.getData().geoObject.balloon.getOverlay().then(() => {
                        $(parentElement).css('overflow-y', 'auto');
                    });
                }
            });

            let plm = new window.ymaps.Placemark([lat, lon], {

                }, {
                    iconLayout: 'default#image',
                    iconImageClipRect: rect,
                    iconImageHref: img_sprite,
                    iconImageSize: [55, 55],
                    iconImageOffset: [-20, -55],
                    balloonContentLayout: baloon
                });

            _this.map.geoObjects.add(plm);
        });

        this.fit();
    }

    fit() {
        let dims = this.map.geoObjects.getBounds();
        this.map.container.fitToViewport();
        let _self = this;
        this.map.setBounds(dims,{checkZoomRange:true}).then(function () {
            if(_self.map.getZoom() > 14) _self.map.setZoom(14);
            else _self.map.setZoom(_self.map.getZoom() - 1);
        });

    }
}

export default YandexMap;
